function r(t) {
  var e = /^[a-f0-9]{32}$/i;
  return e.test(t);
}
export {
  r as isDatabricksId
};
//# sourceMappingURL=isDatabricksId.es.js.map
